/* eslint-disable @typescript-eslint/no-explicit-any */
import { searchByName } from '@/shared/lib/searchByName'
import { useEffect, useState } from 'react'

import { useDebounce } from './useDebounceHook'

import Channel from '@/shared/classes/channels/channel'
import { debounceSpeedMedium } from '@/shared/constants/appConstants'

const useSearchBy = (arrayToFilter: Channel[], searchValue: string) => {
    const [filteredArray, setFilteredArray] = useState(arrayToFilter)
    const debouncedValue = useDebounce(searchValue, debounceSpeedMedium)

    useEffect(() => {
        if (searchValue.length) {
            const filteredArray = searchByName(debouncedValue, arrayToFilter)

            if (filteredArray) setFilteredArray(filteredArray)
        } else setFilteredArray(arrayToFilter)
    }, [debouncedValue])

    return { filteredArray }
}

export { useSearchBy }
